import { Alert, Box, List, Stack, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Done } from "lib/@components/done"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { SendToReviewScheduleRow } from "./send-to-review-schedule-row"
import { SendToReviewResultFailedRow } from "./send-to-review-result-failed-row"

export function SendToReviewResultsDialog({ submitted = [], failed = [], skipped = [] }) {
    const submittedCount = submitted.length
    const failedCount = failed.length
    const skippedCount = skipped.length
    const allSucceeded = failedCount === 0 && skippedCount === 0
    const severity = allSucceeded ? "success" : failedCount > 0 ? "warning" : "info"

    return (
        <DialogBox
            title={
                <Box display="flex" alignItems="center" gap="20px">
                    <Iconify icon={allSucceeded ? "mdi:check-circle-outline" : "mdi:information-outline"} />
                    <Typography variant="h5">Submission Results</Typography>
                </Box>
            }
            Actions={Done}
            okCaption="Close"
            value={true}
            data-cy="send-to-review-results-dialog"
        >
            <Stack spacing={2} sx={{ mt: 1 }}>
                <Alert severity={severity} sx={{ alignItems: "center" }}>
                    <Typography variant="body2">
                        {submittedCount} schedule{submittedCount !== 1 ? "s" : ""} submitted for review
                        {failedCount > 0 ? `, ${failedCount} failed` : ""}
                        {skippedCount > 0 ? `, ${skippedCount} skipped` : ""}.
                    </Typography>
                </Alert>

                <If truthy={submittedCount > 0}>
                    <Stack spacing={1}>
                        <Typography variant="subtitle2" color="success.main">
                            Submitted ({submittedCount})
                        </Typography>
                        <List
                            data-cy="submitted-schedules-list"
                            disablePadding
                            sx={{
                                maxHeight: "15vh",
                                border: 1,
                                borderColor: "success.light",
                                borderRadius: 1,
                                overflowY: "auto",
                            }}
                        >
                            <Repeat
                                list={submitted}
                                item={<SendToReviewScheduleRow color="success.main" />}
                                pass="schedule"
                            />
                        </List>
                    </Stack>
                </If>

                <If truthy={failedCount > 0}>
                    <Stack spacing={1}>
                        <Typography variant="subtitle2" color="error.main">
                            Failed ({failedCount})
                        </Typography>
                        <List
                            data-cy="failed-schedules-list"
                            disablePadding
                            sx={{
                                maxHeight: "15vh",
                                border: 1,
                                borderColor: "error.light",
                                borderRadius: 1,
                                overflowY: "auto",
                            }}
                        >
                            <Repeat list={failed} item={<SendToReviewResultFailedRow />} pass="schedule" />
                        </List>
                    </Stack>
                </If>

                <If truthy={skippedCount > 0}>
                    <Stack spacing={1}>
                        <Typography variant="subtitle2" color="warning.main">
                            Skipped ({skippedCount})
                        </Typography>
                        <List
                            data-cy="skipped-schedules-list"
                            disablePadding
                            sx={{
                                maxHeight: "15vh",
                                border: 1,
                                borderColor: "warning.light",
                                borderRadius: 1,
                                overflowY: "auto",
                            }}
                        >
                            <Repeat list={skipped} item={<SendToReviewResultFailedRow />} pass="schedule" />
                        </List>
                    </Stack>
                </If>
            </Stack>
        </DialogBox>
    )
}
